export const DATE_RANGE_OPTIONS = {
    today: { value: 'today', label: 'Today' },
    tomorrow: { value: 'tomorrow', label: 'Tomorrow' },
    yesterday: { value: 'yesterday', label: 'Yesterday' },
    last7days: { value: 'last7days', label: 'Last 7 Days' },
    last14days: { value: 'last14days', label: 'Last 14 Days' },
    last30days: { value: 'last30days', label: 'Last 30 Days' },
    last60days: { value: 'last60days', label: 'Last 60 Days' },
    last90days: { value: 'last90days', label: 'Last 90 Days' },
    last180days: { value: 'last180days', label: 'Last 180 Days' },
    last365days: { value: 'last365days', label: 'Last 365 Days' },

    wtd: { value: 'wtd', label: 'Week to Date' },
    thisWeek: { value: 'thisWeek', label: 'This Week' },
    lastWeek: { value: 'lastWeek', label: 'Last Week' },
    nextWeek: { value: 'nextWeek', label: 'Next Week' },

    mtd: { value: 'mtd', label: 'Month to Date' },
    thisMonth: { value: 'thisMonth', label: 'This Month' },
    lastMonth: { value: 'lastMonth', label: 'Last Month' },
    nextMonth: { value: 'nextMonth', label: 'Next Month' },
    
    qtd: { value: 'qtd', label: 'Quarter to Date' },
    thisQuarter: { value: 'thisQuarter', label: 'This Quarter' },
    lastQuarter: { value: 'lastQuarter', label: 'Last Quarter' },
    nextQuarter: { value: 'nextQuarter', label: 'Next Quarter' },

    ytd: { value: 'ytd', label: 'Year to Date' },
    thisYear: { value: 'thisYear', label: 'This Year' },
    lastYear: { value: 'lastYear', label: 'Last Year' },

    january: { value: 'january', label: 'January' },
    february: { value: 'february', label: 'February' },
    march: { value: 'march', label: 'March' },
    april: { value: 'april', label: 'April' },
    may: { value: 'may', label: 'May' },
    june: { value: 'june', label: 'June' },
    july: { value: 'july', label: 'July' },
    august: { value: 'august', label: 'August' },
    september: { value: 'september', label: 'September' },
    october: { value: 'october', label: 'October' },
    november: { value: 'november', label: 'November' },
    december: { value: 'december', label: 'December' },

    custom: { value: 'custom', label: 'Custom' },
    all: { value: 'all', label: 'All Time' },
};

export const DATE_RANGE_PRESET_SETS = {
    annual: [
        {
            label: 'Upcoming',
            options: [ 'today', 'tomorrow', 'thisWeek', 'nextWeek', 'thisMonth', 'nextMonth', 'thisQuarter' ],
        },
        {
            label: 'Monthly',
            options: [ 'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december' ],
        },
    ],

    activity: [
        {
            label: 'Recent',
            options: [ 'today', 'yesterday', 'last7days', 'last14days', 'last30days' ],
        },
        {
            label: 'Period to Date',
            options: [ 'thisWeek', 'thisMonth', 'thisQuarter', 'ytd' ],
        },
        {
            label: 'Previous Period',
            options: [ 'lastWeek', 'lastMonth', 'lastQuarter', 'lastYear' ],
        },
        {
            label: 'Other',
            options: [ 'custom', 'all' ],
        },
    ],

    conversion: [
        {
            label: 'Recommended',
            options: [ 'last90days', 'last180days', 'last365days', 'ytd' ],
        },
        {
            label: 'Previous Period',
            options: [ 'lastMonth', 'lastQuarter', 'lastYear' ],
        },
        {
            label: 'Other',
            options: [ 'custom', 'all' ],
        },
    ],

    executive: [
        {
            label: 'Summary Periods',
            options: [ 'thisMonth', 'thisQuarter', 'ytd', 'lastMonth', 'lastQuarter', 'lastYear' ],
        },
        {
            label: 'Rolling Windows',
            options: [ 'last90days', 'last180days', 'last365days' ],
        },
        {
            label: 'Other',
            options: [ 'custom', 'all' ],
        },
    ],

    default: [
        {
            label: 'Recent',
            options: [ 'last30days', 'last90days' ],
        },
        {
            label: 'Period to Date',
            options: [ 'thisMonth', 'thisQuarter', 'ytd' ],
        },
        {
            label: 'Other',
            options: [ 'custom', 'all' ],
        },
    ],
};

export const DATE_RANGE_DEFAULTS = {
    activity: 'last30days',
    annual: 'today',
    conversion: 'last180days',
    executive: 'thisQuarter',
    default: 'last30days',
};